import { isTextual } from "./utils";

import { Toast, Confirm } from "./sweetalert";

import setupCustomBeforeUnload from "./registerBeforeUnload";

const maximumRetryCount = 10;

const retryIntervalMilliseconds = 2000;

const startReconnectionProcess = () => {
    const reconnectModal = document.getElementById("components-reconnect-modal");

    if (reconnectModal) reconnectModal.style.display = "block";

    let isCanceled = false;

    (async () => {
        for (let i = 0; i < maximumRetryCount; i++) {
            if (reconnectModal) reconnectModal.innerText = `Attempting to reconnect: ${i + 1} of ${maximumRetryCount}`;

            await new Promise(resolve => setTimeout(resolve, retryIntervalMilliseconds));

            if (isCanceled || window.connected) {
                return;
            }

            try {
                const result = await window.Blazor?.reconnect();
                if (!result) {
                    // The server was reached, but the connection was rejected; reload the page.
                    location.reload();
                    return;
                }

                window.connected = true;

                // Successfully reconnected to the server.
                return;
            } catch (e) {
                // Didn't reach the server; try again.
            }
        }

        // Retried too many times; reload the page.
        location.reload();
    })();

    return {
        cancel: () => {
            isCanceled = true;
            if (reconnectModal) reconnectModal.style.display = "none";
        }
    };
};

const toTitleCase = (text) => {
    if (text === undefined || text === null) return "";
            
    const textStr = typeof text !== "string" ? String(text) : text;
            
    return textStr.replace(
        /\w\S*/g,
        function (txt) {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        }
    );
};

window.connected = false;

window.BlazorStart = () => {
    let currentReconnectionProcess = null;

    window?.Blazor.start({
        reconnectionOptions: {
            maxRetries: 5,
            retryIntervalMilliseconds: 1000
        },
        reconnectionHandler: {
            onConnectionDown: () => {
                window.connected = false;
                if (!currentReconnectionProcess) {
                    currentReconnectionProcess = startReconnectionProcess();
                }
            },
            onConnectionUp: () => {
                currentReconnectionProcess?.cancel();
                currentReconnectionProcess = null;
            }
        }
    }).then(() => {
        window.connected = true;
    }).catch(() => {
        window.connected = false;
    });
}

(() => {
    "use strict";

    Object.defineProperty(WebSocket, "OPEN", { value: 1 });

    // jquery-validation defaults
    window.$.validator.setDefaults({
        showErrors: function (errorMap, errorList) {
            if (this.currentForm.classList.contains("was-validated")) {
                this.defaultShowErrors();
                errorList.forEach(error => {
                    const control = error.element;
                    control.setCustomValidity(error.message);
                    if (!control.dataset.eventChangeAttached) {
                        control.dataset.eventChangeAttached = true;
                        control.addEventListener(isTextual(control) ? "input" : "change", () => {
                            const isValidElement = window.$(error.element).valid();
                            control.setCustomValidity(isValidElement ? "" : error.message);
                        });
                    }
                });
            }
        }
    });

    // Fetch all the forms we want to apply custom Bootstrap validation styles to
    const forms = document.querySelectorAll(".needs-validation");

    // Loop over them and prevent submission
    Array.prototype.slice.call(forms).forEach(function (form) {
        form.addEventListener("submit", function (event) {
            if (!form.checkValidity()) {
                event.preventDefault();
                event.stopPropagation();
            } else {
                const btnSubmit = form.querySelector(".btn[type=submit]");
                if (btnSubmit) {
                    const spinner = btnSubmit.querySelector(".spinner-border");
                    if (spinner) {
                        btnSubmit.disabled = true;
                        spinner.classList.remove("d-none");
                    }
                }
            }

            form.classList.add("was-validated");
        }, false);
    });
})();

(() => {
    window?.BlazorStart();
})();

window.addEventListener("pageshow", () => {
    if (!connected && window.Blazor) {
        window?.BlazorStart();
    }
});

window.addEventListener("unload", () => {
    if (connected) {
        window.Blazor?.disconnect();
    }
});

window.addEventListener("keydown", function (e) {
    // Block F5 and Ctrl+R 
    if ((e.altKey && e.key === "F4") || e.key === "F5" || ((e.ctrlKey && e.shiftKey) && (e.key === "r" || e.key === "R")) || (e.ctrlKey && e.key === "r") || e.keyCode === 116) {
        const message = "Non &egrave; possibile ricaricare la pagina in questo contesto, se necessario usare il pulsante del browser...";

        event.cancel = true;

        event.preventDefault();

        Confirm.fire({
            title: toTitleCase("Refresh Disabilitato"),
            html: message,
            icon: "warning",
            timer: 3500,
            timerProgressBar: true,
            showConfirmButton: false,
            width: "auto"
        });

        event.returnValue = null;
    }
});

window.Cookie = {
    acceptMessage: function (cookieString) {
        document.cookie = cookieString;
    },
    denyMessage: function () {
        document.cookie = null;
    }
};

window.Functions = {
    setDoodle: function () {
        const main = document.querySelector(".main");

        main?.addEventListener("click", dUpdate);

        function dUpdate(withFrame = true) {
            const doodle = document.querySelector(".doodle");
            if (!withFrame) {
                doodle?.update();
                return;
            }
            window.requestAnimationFrame(() => doodle?.update());
        }

        window.setInterval(function () {
            dUpdate(false);
        }, 5000);
    },
    setReadonly: function () {
        setTimeout(() => {
            document.querySelectorAll(".readonly.disabled").forEach(element => {
                element.setAttribute("readonly", "readonly");
                element.setAttribute("disabled", "disabled");
            });
        }, 150);
    },
    showToast: function (title, icon = "success") {
        let html;

        if (!title) {
            html = toTitleCase(icon);
        } else {
            html = title?.replace(/(\r|\n|\r\n|\\r\\n|\\r|\\n)/g, "<br>");
        }
        Toast.fire({
            icon: icon,
            title: html,
            width: "auto"
        });
    },
    showConfirm: function (title, text, icon = "question", showCancelButton = true, confirmButtonText = "Yes", cancelButtonText = "No", dotNetObject = null) {
        Confirm.fire({
            title: toTitleCase(title),
            html: text?.replace(/(\r|\n|\r\n|\\r\\n|\\r|\\n)/g, "<br>"),
            icon: icon,
            showCancelButton: showCancelButton,
            confirmButtonText: confirmButtonText,
            cancelButtonText: cancelButtonText,
            width: "auto"
        }).then(result => {
            const res = result.isConfirmed;
            if (dotNetObject) {
                dotNetObject?.reference?.invokeMethodAsync(dotNetObject.action, result.isConfirmed);
            }
            return res ?? false;
        });
    },
    showConfirmNoCallback: async function(title, text, icon = "question", showCancelButton = true, confirmButtonText = "Yes", cancelButtonText = "No") {
        return await Confirm.fire({
            title: toTitleCase(title),
            html: text?.replace(/(\r|\n|\r\n|\\r\\n|\\r|\\n)/g, "<br>"),
            icon: icon,
            showCancelButton: showCancelButton,
            confirmButtonText: confirmButtonText,
            cancelButtonText: cancelButtonText,
            width: "auto"
        }).then(result => {
            const res = result.isConfirmed;
            
            return res ?? false;
        });
    },
    showConfirmWithParams: function (title, text, icon = "question", showCancelButton = true, confirmButtonText = "Yes", cancelButtonText = "No", dotParam = [], dotNetObject = null) {
        Confirm.fire({
            title: toTitleCase(title),
            html: text?.replace(/(\r|\n|\r\n|\\r\\n|\\r|\\n)/g, "<br>"),
            icon: icon,
            showCancelButton: showCancelButton,
            confirmButtonText: confirmButtonText,
            cancelButtonText: cancelButtonText,
            width: "auto"
        }).then(result => {
            const res = result.isConfirmed;
            if (dotNetObject) {
                dotNetObject?.reference?.invokeMethodAsync(dotNetObject.action, result.isConfirmed, dotParam);
            }
            return res ?? false;
        });
    },
    showAutoClose: function (title, text, icon = "question", time = 5000) {
        Confirm.fire({
            title: toTitleCase(title),
            html: text?.replace(/(\r|\n|\r\n|\\r\\n|\\r|\\n)/g, "<br>"),
            icon: icon,
            timer: time,
            timerProgressBar: true,
            showConfirmButton: false,
            width: "auto"
        });
    },
    initBootstrapSelect: function (element = ".selectpicker") {
        window.$(element).selectpicker();
    },
    scrollToBottom: function (textarea) {
        return textarea.scrollTop = textarea.scrollHeight;
    },
    initScrollTop: function () {
        const main = document.querySelector("main.main");
        const scrollToTopButton = document.getElementById("js-top");

        const scrollFunc = () => {
            const y = main.scrollTop;

            if (y > 0) {
                scrollToTopButton.className = "top-link show";
            } else {
                scrollToTopButton.className = "top-link hide";
            }

            document.documentElement.style.setProperty(
                "--scroll", y / (main.scrollHeight - window.innerHeight)
            );
        };

        main.addEventListener("scroll", scrollFunc);

        const scrollToTop = () => {
            const c = main.scrollTop || document.documentElement.scrollTop || document.body.scrollTop;

            const jMain = window.$(main);

            if (c > 0) {
                jMain.animate({ scrollTop: 0 }, c / 100, "swing");
                jMain.focus();
            }
        };

        scrollToTopButton.onclick = function (e) {
            e.preventDefault();
            scrollToTop();
        }
    },
    removeStyleOnChooser: function () {
        document.querySelectorAll(".k-popup.k-list-container.k-dropdownlist-popup").forEach(dropPop => {
            dropPop.style.height = null;
        });
    },
    hasWhiteSpace: function () {
        const grid = document.querySelector(".k-grid");
        const gridTable = document.querySelector(".k-grid-table");

        if (typeof grid === "undefined" || typeof gridTable === "undefined" || !grid || !gridTable) {
            return false;
        }

        return grid?.offsetWidth > gridTable?.offsetWidth;
    },
    loaderToggle: function (show = false) {
        const loader = document.querySelector(".seperator-wrapper");
        if (!show) {
            if (loader) loader.style.display = "none";
        } else {
            if (loader) loader.style.display = "block";
        }
    },
    loaderNewToggle: function (show = false) {
        const loaderNew = document.querySelector(".layer-loader");
        if (!show) {
            if (loaderNew) loaderNew.style.display = "none";
        } else {
            if (loaderNew) loaderNew.style.display = "block";
        }
    },
    changeCss: function (cssFileUrl, tokenFileUrl) {
        const oldLink = document.getElementById("TelerikThemeLink"); // we have this id on the <link> that references the theme
        const oldLinkToken = document.getElementById("TelerikThemeLinkToken"); // we have this id on the <link> that references the theme

        if (cssFileUrl === oldLink.getAttribute("href")) {
            return;
        }

        oldLink.setAttribute("href", cssFileUrl);
        oldLinkToken.setAttribute("href", tokenFileUrl);
    },
    saveFile: function (bytesBase64, mimeType, fileName) {
        const fileUrl = `data:${mimeType};base64,${bytesBase64}`;
        fetch(fileUrl)
            .then(response => response.blob())
            .then(blob => {
                var link = window.document.createElement("a");
                link.href = window.URL.createObjectURL(blob, { type: mimeType });
                link.download = fileName;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            });
    },
    revealPassword: function (cName, text = "Show password", textHide = "Hide password") {
        const inputElem = document.querySelector(`input.${cName}`);
        const spanElem = document.querySelector(`span.${cName}`);
        if (inputElem.type === "password") {
            inputElem.type = "text";
            spanElem.classList.remove("bi-eye");
            spanElem.classList.add("bi-eye-slash");
            spanElem.title = textHide;
        } else {
            inputElem.type = "password";
            spanElem.classList.remove("bi-eye-slash");
            spanElem.classList.add("bi-eye");
            spanElem.title = text;
        }
    },
    getViewPortSize: function () {
        return { Width: window.innerWidth, Height: window.innerHeight };
    },
    uncheckAll: function () {
        document.querySelectorAll("input[type=checkbox].k-checkbox.k-grid-checkbox")?.forEach(function (checkbox) {
            checkbox.checked = false;
        });
    },
    checkAll: function () {
        document.querySelectorAll("input[type=checkbox].k-checkbox.k-grid-checkbox")?.forEach(function(checkbox) {
             checkbox.checked = true;
        });
    },
    getHeadCheckVal: function () {
        const checkbox = document.querySelector("input[type=checkbox].k-checkbox");
        return checkbox ? checkbox.checked : false;
    },
    getCheckVal: function (idx) {
        if (idx < 0) {
            return false;
        }
        const checkboxes = document.querySelectorAll("input[type=checkbox].k-checkbox.k-grid-checkbox");
        return checkboxes[idx] ? checkboxes[idx].checked : false;
    },
    addDefaultPreventingHandler: function (element, eventName) {
        element.addEventListener(eventName, e => e.preventDefault(), { passive: false });
    },
    resizeListener: function (dotnethelper) {
        window.$(window).resize(() => {
            const browserHeight = window.$(window).innerHeight();
            const browserWidth = window.$(window).innerWidth();
            dotnethelper?.invokeMethodAsync("SetBrowserDimensions", browserWidth, browserHeight).then(() => {
                // success, do nothing
            }).catch(e => {
                console.dir(e);
            });
        });
    },
    registerUnload: function (dotnethelper, titleAlert, messageAlert, icon) {
        window.layoutHelper = dotnethelper || {};
        
        //window.removeBeforeUnloadHandler = setupCustomBeforeUnload({
        //    title: toTitleCase(titleAlert),
        //    message: messageAlert,
        //    icon: icon,
        //    onConfirm: () => { window.logout(); },
        //    onCancel: () => { window.layoutHelper?.invokeMethodAsync("CancelUnload"); }
        //});
    },
    removeHandler: function() {
        window.removeBeforeUnloadHandler();
    },
    logout: function () {
        window.logout();
    }
}

window.onlineStatusIndicator = {
    registerOnlineStatusHandler: function (dotNetObjRef) {
        function onlineStatusHandler() {
            dotNetObjRef?.invokeMethodAsync("SetOnlineStatusColor", navigator.onLine);
        };

        onlineStatusHandler();

        window.addEventListener("online", onlineStatusHandler);
        window.addEventListener("offline", onlineStatusHandler);
    }
};

window.dotnethelper = {};

window.timeOutInit = function (dotnethelper, msInterval) {
    let timer;

    window.layoutHelper = dotnethelper;

    document.onmousemove = resetTimeDelay;
    document.onkeypress = resetTimeDelay;

    function resetTimeDelay() {
        clearTimeout(timer);
        timer = setTimeout(innerLogout, msInterval);
    }

    function innerLogout() {
        dotnethelper?.invokeMethodAsync("AutoLogout");
    }
}

window.logout = function () {
    try {
        window.mutation?.disconnect();
        window.Functions.removeHandler();
    } catch (e) {
        // ignored
    } finally {
        window.layoutHelper?.invokeMethodAsync("AutoLogout");
    }
}

// Observe the body for the reconnect modal to appear, and when it does, start polling the server to see if it's back
window.mutationReconnect = new MutationObserver((mutations, observer) => {
    if (document.querySelector("#components-reconnect-modal h5 a")) {
        // Now every 10 seconds, see if the server appears to be back, and if so, reload
        async function attemptReload() {
            await fetch(""); // Check the server really is back
            location.reload();
        }

        observer.disconnect();
        attemptReload();
        setInterval(attemptReload, 2000);
    }
}).observe(document.body, { childList: true, subtree: true });

window.initSearchAnimation = function (root, delay, duration, strokeWidth, timingFunction, strokeColor, repeat) {
    const paths = root.querySelectorAll("path");
    const mode = repeat ? "infinite" : "forwards";

    for (let i = 0; i < paths.length; i++) {
        const path = paths[i];
        const length = path.getTotalLength();
        path.style["stroke-dashoffset"] = `${length}px`;
        path.style["stroke-dasharray"] = `${length}px`;
        path.style["stroke-width"] = `${strokeWidth}px`;
        path.style["stroke"] = `${strokeColor}`;
        path.style["animation"] = `${duration}s svg-text-anim ${mode} ${timingFunction}`;
        path.style["animation-delay"] = `${i * delay}s`;
    }
}